
//完整引入 elemaent ui ------start-------------------------------------
//import ElementUI from 'element-ui'
//完整引入 elemaent ui ------end-------------------------------------

//完整引入 elemaent ui 时， 样式必须也要引入
import 'element-ui/lib/theme-chalk/index.css'
import {   
	Select, Option, OptionGroup,Radio,RadioGroup
} from 'element-ui';
import Vue from 'vue';
/**********布局的相关组件***************************************/
Vue.use(Select)  //使用 Alert 组件
Vue.use(Option)  //使用 Alert 组件 
Vue.use(OptionGroup)  //使用 Alert 组件 
Vue.use(Radio)  //使用 Alert 组件 
Vue.use(RadioGroup)  //使用 Alert 组件 


// WEBPACK FOOTER //
// ./src/element/element.js